// Internal Imports
import { isoDateToString } from "../../util/format-date";
import Heading from "../UI/Heading";
import DetailPair from "../UI/DetailPair";
import PersonCard from "../UI/PersonCard";
import { MdClose } from "react-icons/md";
import Modal from "../UI/Modal";
import { toTitleCase } from "../../util/format-text";

/** ========================================================================
 * * Audit Information Modal
 * Renders a modal, which displays all information about an audit record.
 * ========================================================================== */
export default function AuditInfo({ open, setOpen, audit }) {
  return (
    <Modal open={open} setOpen={setOpen}>
      <div className="modal max-w-[900px]">
        <Heading title="Audit Information" id={audit?.id} isBackArrow={false}>
          <MdClose onClick={() => setOpen(false)} className="icon" />
        </Heading>
        <div className="grid gap-4 lg:grid-cols-3">
          <div className="info lg:grid-cols-1">
            <DetailPair
              label="Date Created"
              value={isoDateToString(audit?.dateCreated, "MM/dd/yyyy")}
            />
            <DetailPair
              label="Action"
              classes="font-semibold"
              value={audit?.action?.toUpperCase()}
            />
            <DetailPair label="Table" value={audit?.table} />
            <DetailPair label="Item ID" value={audit?.row} />
            <PersonCard
              name={audit?.agent?.name || "Unknown Agent"}
              image={audit?.agent?.photo}
              label="Perfomed By:"
              secondary={toTitleCase(audit?.agent?.type) || ""}
              link={`/employees/info?id=${audit?.agentId}`}
            />
          </div>
          <div className="lg:col-span-2">
            <textarea
              className="w-full h-full form-input-disabled"
              value={audit && JSON.stringify(JSON.parse(audit?.data), null, 2)}
              disabled
            />
          </div>
        </div>
      </div>
    </Modal>
  );
}
